<template>
    <div class="mx-auto w-full max-w-screen-3xl">
        <nav>
            <ol class="flex items-center">
                <li
                    v-for="(group, index) in filteredGroups"
                    :key="group"
                    :class="{ 'opacity-25': !isEnabledStep(group.name) }"
                    class="w-1/3 pb-2 px-3.5 text-base transition-all duration-300 ease-in"
                >
                    <button
                        type="button"
                        :disabled="!isEnabledStep(group.name)"
                        @click="setCurrentStep(group.name)"
                        :class="[
                            { 'justify-start': index === 0 },
                            { 'justify-center': index !== 0 && index + 1 !== filteredGroups.length },
                            { 'justify-end': index + 1 === filteredGroups.length },
                        ]"
                        class="flex w-full h-full"
                    >
                        <option-group-name
                            :group-index="index"
                            :group-name="group.name"
                        />
                    </button>
                </li>
            </ol>
        </nav>

        <progress-bar />
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import OptionGroupName from './OptionGroupName.vue';
    import ProgressBar from './ProgressBar.vue';

    export default {
        mixins: [allStores],

        components: {
            OptionGroupName,
            ProgressBar,
        },

        computed: {
            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },

            filteredGroups() {
                return this.allGroups?.filter((group) => group.custom['oe-hide'] !== 'true');
            },

            currentStep() {
                return this.appStore.currentStep;
            },
        },

        methods: {
            isEnabledStep(groupName) {
                return this.appStore.isEnabledStep(groupName);
            },

            setCurrentStep(groupName) {
                const stepName = `select${groupName}`;

                this.appStore.setCurrentStep(stepName);
            },

            getCurrentGroup() {
                if (this.allGroups?.length) {
                    // Filter out groups not used for main customization experience (personalization, label)
                    const filteredGroups = this.allGroups?.filter((group) => group.custom['oe-hide'] !== 'true');

                    if (this.isMobile && this.currentStep.includes('select')) {
                        const groupName = this.currentStep.split('select')[1];
                        const result = filteredGroups.find((group) => group.name === groupName);

                        return [result];
                    }

                    return filteredGroups;
                }

                return {};
            },
        },
    };
</script>
